<template>
  <div class="rcc-table-list">
    <div class="rcc-table-list__button-wrapper" v-if="editAccess">
      <rcc-button @click="$router.push({ name: 'return-statuses-new' })">
        Добавить статус возврата
      </rcc-button>
    </div>
    <div class="rcc-table-list__table-wrapper">
      <rcc-table
        :page.sync="page"
        :pageCount="pagesCount"
        :itemsPerPage="rowsOnTable"
        :headers="headers"
        :rows="rows"
        :is-fixed-header="true"
        :isShowFilters="false"
        :isLoading="isDataLoading"
        @filters-changed="handleFiltersChanged"
      />
    </div>
  </div>
</template>

<script>
import Page from '@/mixins/page'
import TableList from '@/mixins/table-list'
import ReturnStatusesApi from '@/api/return-statuses'
import headerData from './header'

import RccTable from 'Components/table/rcc-table'
import RccButton from 'Components/controls/rcc-button'

export default {
  mixins: [Page, TableList, ReturnStatusesApi],

  components: {
    RccTable,
    RccButton
  },

  computed: {
    headerData() {
      return headerData
    }
  },

  methods: {
    loadData(filters) {
      this.isDataLoading = true

      this.getReturnStatuses({ page: this.page, per_page: this.rowsOnTable, ...filters })
        .then(({ pages, items }) => {
          if (!pages) {
            this.resetTableData()
            return
          }

          this.pagesCount = pages

          this.rows = items
        })
        .finally(() => { this.isDataLoading = false })
    }
  }
}
</script>
